import { daysFormat, monthFormat } from '@/filters'
import {
  getSameAttribute,
  classifyArray,
  resetAttribute,
  resetAttributes
} from '@/utils/handleData.js'
import { roundMoney } from '@/utils/getCalculatedValue.js'
import {
  getPie,
  getEmptyPie,
  getliquidfill,
  getLine,
  getBar
} from '@/utils/getChartOption.js'
import { isAnalysisBidOrg, isAnalysisCompanyOrg, isAnalysisLaborOrg } from '@/utils/analysisMenu'
import { collectReportTemplates, mergeReportGroups } from '@/utils/platformPages'
import {
  filterByCategory,
  REALNAME_GROUPS,
  PRECLASS_GROUPS,
  buildTemplateTree,
  decorateTemplateTree,
  sanitizeTemplateMark
} from '@/utils/reportCategories'

function reportTemplateMeta(rootState) {
  const step = (rootState.currentStep && rootState.currentStep.step) || ''
  const org = step.indexOf('Org') >= 0
  const category = step.indexOf('preClass') === 0 ? 'preClass' : 'realname'
  return {
    org: org,
    category: category,
    groups: category === 'preClass' ? PRECLASS_GROUPS : REALNAME_GROUPS,
    orgUid: org ? rootState.activeNav || '' : ''
  }
}

function normalizeTemplateForm(form, rootState) {
  const meta = reportTemplateMeta(rootState)
  const group =
    meta.groups.find((item) => item.value === (form && form.templateGroupCode)) ||
    meta.groups[0]
  const types = Array.isArray(form && form.applicableOrgTypes)
    ? form.applicableOrgTypes.join(',')
    : (form && form.applicableOrgTypes) || ''
  const userCustom =
    form && (form.userCustom === true || form.userCustom === 'true')
  return {
    uid: form && form.uid,
    customUid: form && form.customUid,
    orgUid: (rootState && rootState.activeNav) || '',
    templateCode: form && form.templateCode,
    templateName: form && form.templateName,
    templateGroupCode: (form && form.templateGroupCode) || (group && group.value),
    templateGroupName: (form && form.templateGroupName) || (group && group.label),
    reportName: form && form.templateName,
    isShow: form && (form.isShow === false || form.isShow === 'false') ? 'false' : 'true',
    sort: (form && form.sort) || '',
    userCustom: userCustom ? 'true' : 'false',
    templateFlg: userCustom ? 'userCustom' : 'system',
    applicableOrgTypes: types || 'simPro,laborCom',
    reportBaseUrl: form && form.reportBaseUrl,
    reportTemplateName: form && form.reportTemplateName,
    mark: sanitizeTemplateMark(form && form.mark)
  }
}

const KPI_RATE_COLOR = '#ff5010'
const KPI_COUNT_COLOR = '#24b153'
const kpiRateStyle = () => ({ color: KPI_RATE_COLOR })
const kpiCountStyle = (warn) => ({
  color: warn ? KPI_RATE_COLOR : KPI_COUNT_COLOR
})

export default {
  namespaced: true,
  state: {
    monitorIndexs: [],
    statisticAnalysis: [],
    changeTrend: [],
    salaryArrears: [],
    realnameManageReport: [], // 实名制管理报表
    realnameCheckReport: [], // 实名制查询报表
    preClassReport: [], // 班前教育报表
    reportGroups: [], // 机构报表页动态分组 Tab
    templateTree: [],
    availableTemplates: [],
    platformOrgOverview: {},
    platformPersonOverview: {},
    platformCarOverview: {},
    onSiteTip: '',
    preClassKpis: [],
    preClassCharts: [],
    preClassTrend: {},
    preClassUndone: [],
    preClassTrendBids: [],
    preClassTrendLabors: [],
    preClassTrendTeams: [],
    materialAnalysis: {}
  },
  actions: {
    /********************************************** 实名制数据分析 ********************************************************/

    // 获取顶部主要当前实时指标数据
    async getRealnameMonitorIndexs({ rootState, rootGetters, commit, dispatch }) {
      var data = {
        organUid: rootState.user.orgValue,
        monthTime: daysFormat(new Date())
      }
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/udf/project/toppart', data: data },
        { root: true }
      )
      const pickNum = (obj, keys, fallback) => {
        if (!obj) return fallback
        for (let i = 0; i < keys.length; i++) {
          const value = obj[keys[i]]
          if (value !== undefined && value !== null && value !== '') {
            const num = Number(value)
            if (!isNaN(num)) return num
          }
        }
        return fallback
      }
      const trendItem = (label, value) => {
        const num = Number(value) || 0
        return {
          label: label,
          value: num,
          class: num >= 0 ? 'el-icon-top' : 'el-icon-bottom',
          style: kpiCountStyle(num !== 0)
        }
      }
      const countItem = (label, value, warnWhenZero) => {
        const num = Number(value) || 0
        return {
          label: label,
          value: num,
          style: kpiCountStyle(warnWhenZero && num === 0)
        }
      }
      const rateItem = (label, value) => {
        const num = Number(value) || 0
        return {
          label: label,
          value: num + '%',
          style: kpiRateStyle()
        }
      }
      if (res.data) {
        let laborPerson = {
          label: '在场劳务人员',
          value: 0,
          icon: 'iconfont icon-gongren',
          span: 4,
          compares: []
        }
        let laborAttendance = {
          label: '劳务人员出勤率',
          value: '0%',
          icon: 'iconfont icon-kaoqintongji',
          span: 4,
          compares: []
        }
        let managePerson = {
          label: '在场管理人员',
          value: 0,
          icon: 'iconfont icon-ren',
          span: 4,
          compares: []
        }
        let laborCompany = {
          label: '在场劳务公司',
          value: 0,
          icon: 'iconfont icon-gongsi',
          span: 4,
          compares: []
        }
        let lastMonthLaborChange = 0
        let laborContractRate = 0
        let adminActual = 0
        let adminShould = 0
        for (const key in res.data) {
          if (Object.hasOwnProperty.call(res.data, key)) {
            const element = res.data[key].data
            if (key === 'daysmoreworkers' && element) {
              laborPerson.value = element.count ? element.count : 0
            } else if (key === 'twomonthworkers' && element) {
              lastMonthLaborChange = (element.actNum || 0) - (element.lastNum || 0)
            } else if (key === 'attendance' && element) {
              laborAttendance.value = !element.shouldNum
                ? '0%'
                : ((element.actualNum / element.shouldNum) * 100).toFixed(1) +
                  '%'
              laborAttendance.compares = [
                countItem('出勤人数', element.actualNum || 0, false)
              ]
            } else if (key === 'adminatten' && element) {
              adminShould = element.shouldNum ? element.shouldNum : 0
              adminActual = element.actualNum ? element.actualNum : 0
              managePerson.value = adminShould
            } else if (key === 'monthmoretype' && element) {
              laborCompany.value = element.currentMonth
                ? element.currentMonth
                : 0
              laborContractRate = element.recordLabor ? element.recordLabor : 0
            }
          }
        }
        const statsRes = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/person/list/onsitestats',
            data: { orgUid: rootState.user.orgValue },
            noErrorMsg: true
          },
          { root: true }
        )
        const stats =
          statsRes && statsRes.code === 200 && statsRes.data
            ? statsRes.data
            : null
        let tipText = ''
        let teamOnSite = 0
        let teamExit = 0
        let teamDissolve = 0
        let laborCompanyExit = 0
        let laborCompanyArrears = 0
        let laborAttendCount = 0
        let bidBuilding = 0
        let bidCompleted = 0
        let bidOther = 0
        let projectBuilding = 0
        let projectCompleted = 0
        let projectOther = 0
        if (stats) {
          const laborOnSite = pickNum(stats, ['laborOnSite', 'laboronsite'], 0)
          const laborMulti = pickNum(
            stats,
            ['laborMultiCompany', 'labormulticompany'],
            0
          )
          const adminOnSite = pickNum(stats, ['adminOnSite', 'adminonsite'], 0)
          const adminMulti = pickNum(
            stats,
            ['adminMultiCompany', 'adminmulticompany'],
            0
          )
          const laborContractCount = pickNum(
            stats,
            ['laborContractCount', 'laborcontractcount'],
            0
          )
          laborCompany.value = pickNum(
            stats,
            ['laborCompanyOnSite', 'laborcompanyonsite'],
            laborCompany.value
          )
          laborCompanyExit = pickNum(
            stats,
            ['laborCompanyExit', 'laborcompanyexit'],
            0
          )
          teamOnSite = pickNum(stats, ['teamOnSite', 'teamonsite'], 0)
          teamExit = pickNum(stats, ['teamExit', 'teamexit'], 0)
          teamDissolve = pickNum(stats, ['teamDissolve', 'teamdissolve'], 0)
          laborCompanyArrears = pickNum(
            stats,
            ['laborCompanyArrears', 'laborcompanyarrears'],
            0
          )
          laborAttendCount = pickNum(
            stats,
            ['laborAttendCount', 'laborattendcount'],
            0
          )
          bidBuilding = pickNum(stats, ['bidBuilding', 'bidbuilding'], 0)
          bidCompleted = pickNum(stats, ['bidCompleted', 'bidcompleted'], 0)
          bidOther = pickNum(stats, ['bidOther', 'bidother'], 0)
          projectBuilding = pickNum(
            stats,
            ['projectBuilding', 'projectbuilding'],
            0
          )
          projectCompleted = pickNum(
            stats,
            ['projectCompleted', 'projectcompleted'],
            0
          )
          projectOther = pickNum(stats, ['projectOther', 'projectother'], 0)
          laborPerson.value = laborOnSite
          managePerson.value = adminOnSite
          if (laborOnSite > 0) {
            laborContractRate = Number(
              ((laborContractCount / laborOnSite) * 100).toFixed(1)
            )
          }
          const tips = []
          if (laborMulti > 0) {
            tips.push(
              '当前标段在场劳务人员' +
                laborOnSite +
                '人，其中' +
                laborMulti +
                '人同时在场多个劳务公司'
            )
          }
          if (adminMulti > 0) {
            tips.push(
              '当前标段在场管理人员' +
                adminOnSite +
                '人，其中' +
                adminMulti +
                '人同时在场多个管理单位'
            )
          }
          tipText = tips.join('；')
        }
        const adminRatio =
          !adminShould || !adminActual ? 0 : (adminActual / adminShould) * 100
        const statsAttendRate =
          laborPerson.value > 0
            ? Number(((laborAttendCount / laborPerson.value) * 100).toFixed(1))
            : Number(String(laborAttendance.value).replace('%', '')) || 0
        const isBidLevel = isAnalysisBidOrg(rootGetters['user/orgType'])
        laborPerson.compares = isBidLevel
          ? [
              trendItem('较上月', lastMonthLaborChange),
              rateItem('合同备案率', laborContractRate)
            ]
          : [
              rateItem('出勤率', statsAttendRate),
              rateItem('合同备案率', laborContractRate)
            ]
              managePerson.compares = [
          countItem('出勤人数', adminActual, false),
                {
                  label: '出勤率',
            value: adminRatio ? adminRatio.toFixed(1) + '%' : '0%',
            style: kpiRateStyle()
          }
        ]
              laborCompany.compares = [
          countItem('退场', laborCompanyExit, false),
          {
            label: '欠薪',
            value: laborCompanyArrears,
            style: kpiCountStyle(laborCompanyArrears > 0)
          }
        ]
        const teamCard = {
          label: '在场班组',
          value: teamOnSite,
          icon: 'iconfont icon-gongzuojingyan',
          span: 4,
          compares: [
            countItem('退场', teamExit, false),
            countItem('解散', teamDissolve, false)
          ]
        }
        const monitorIndexs = isBidLevel
          ? [
          laborPerson,
          laborAttendance,
          managePerson,
              Object.assign({}, laborCompany, {
                clickable: laborCompanyArrears > 0,
                clickAction: 'salaryArrears'
              }),
              teamCard
            ]
          : [
              laborPerson,
              teamCard,
              Object.assign({}, laborCompany, {
                clickable: laborCompanyArrears > 0,
                clickAction: 'salaryArrears'
              }),
              {
                label: '在建项目标段',
                value: bidBuilding,
                icon: 'iconfont icon-category',
                span: 4,
                compares: [
                  countItem('完工', bidCompleted, false),
                  countItem('其他', bidOther, false)
                ]
              },
              {
                label: '在建工程',
                value: projectBuilding,
                icon: 'iconfont icon-icon_huabanfuben',
                span: 4,
                compares: [
                  countItem('竣工', projectCompleted, false),
                  countItem('其他', projectOther, false)
                ]
              }
            ]
        commit(
          'baseSet',
          {
            module: 'dataAnalysis',
            key: 'onSiteTip',
            value: tipText
          },
          { root: true }
        )
        commit(
          'baseSet',
          {
            module: 'dataAnalysis',
            key: 'monitorIndexs',
            value: monitorIndexs
          },
          { root: true }
        )
      } else {
        commit(
          'baseSet',
          { module: 'dataAnalysis', key: 'monitorIndexs', value: [] },
          { root: true }
        )
        commit(
          'baseSet',
          { module: 'dataAnalysis', key: 'onSiteTip', value: '' },
          { root: true }
        )
      }
    },
    async getSalaryArrears({ rootState, commit, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/person/list/salaryarrears',
          data: { orgUid: rootState.user.orgValue },
          noErrorMsg: true
        },
        { root: true }
      )
      const raw =
        res && res.code === 200 && Array.isArray(res.data) ? res.data : []
      const rows = raw.map((item) => {
        const shouldPay = roundMoney(item.shouldPay || item.shouldpay || 0)
        const actualPay = roundMoney(item.actualPay || item.actualpay || 0)
        const owePay = roundMoney(
          item.owePay != null || item.owepay != null
            ? item.owePay || item.owepay || 0
            : shouldPay - actualPay
        )
        return {
          companyName: item.companyName || item.companyname || '',
          bidName: item.bidName || item.bidname || '',
          shouldPay,
          actualPay,
          owePay,
          payRate: item.payRate || item.payrate || 0
        }
      })
      commit(
        'baseSet',
        {
          module: 'dataAnalysis',
          key: 'salaryArrears',
          value: rows
        },
        { root: true }
      )
      return rows
    },
    // 获取中部截止当前分析指标数据
    async getRealnameStatisticAnalysis({ rootState, commit, dispatch }) {
      var data = {
        organUid: rootState.user.orgValue,
        monthTime: daysFormat(new Date())
      }
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/udf/project/middlepart', data: data },
        { root: true }
      )
      // console.log(res)
      if (res.data) {
        let statisticAnalysis = []
        let salaryPay = {
          label: '薪酬发放情况',
          title: {
            icon: 'iconfont icon-consumption-fill',
            name: '薪酬发放情况'
          },
          dataCompare: [],
          charts: [],
          chartNotes: [
            {
              label: '数据统计截止：',
              value:
                new Date().getFullYear() + '年' + new Date().getMonth() + '月',
              style: { color: '#047bff' }
            },
            {
              label: '数据单位：',
              value: '元',
              style: { color: '#047bff' }
            }
          ],
          span: 12
        }
        let businessChart = null
        let ageChart = null
        let nativeChart = null
        for (const key in res.data) {
          if (Object.hasOwnProperty.call(res.data, key)) {
            let element = res.data[key].data
            if (
              (key === 'businessdistribute' ||
                key === 'countnative' ||
                key === 'agedistribute') &&
              element
            ) {
              if (key === 'businessdistribute') {
                element = resetAttribute(element, 'business', 'total')
                businessChart = pieChartFromRows(
                  key,
                  '工种',
                  element,
                  0
                )
              } else if (key === 'agedistribute') {
                element = resetAttribute(element, 'case', 'count')
                ageChart = pieChartFromRows(key, '年龄', element, 0)
              } else if (key === 'countnative') {
                element = resetAttribute(element, 'province', 'ctNumber')
                nativeChart = pieChartFromRows(key, '籍贯', element, 0)
              }
            } else if (key === 'towmonthwages' && element) {
              const payRate = !element.total
                ? 0
                : (element.total / 100).toFixed(1)
              const cumuShouldPay = roundMoney(element.cumuShouldPay)
              const cumuActualPay = roundMoney(element.cumuActualPay)
              const cumuOwePay = roundMoney(cumuShouldPay - cumuActualPay)
              const currentShouldPay = roundMoney(element.currentShouldPay)
              const currentActualPay = roundMoney(element.currentActualPay)
              const currentOwePay = roundMoney(element.currentOwePay)
              salaryPay.dataCompare = [
                {
                  label: '累计应发',
                  value: cumuShouldPay,
                  style: { color: '#047bff' },
                  compare: {
                    label: '较前月',
                    value: currentShouldPay,
                    icon: 'el-icon-top',
                    style:
                      currentShouldPay === 0
                        ? { color: '#ff5010' }
                        : { color: '#24b153' }
                  }
                },
                {
                  label: '累计实发',
                  value: cumuActualPay,
                  style: { color: '#36aa78' },
                  compare: {
                    label: '较前月',
                    value: currentActualPay,
                    icon: 'el-icon-top',
                    style:
                      currentActualPay === 0
                        ? { color: '#ff5010' }
                        : { color: '#24b153' }
                  }
                },
                {
                  label: '累计欠发',
                  value: cumuOwePay,
                  style: { color: '#ff7a2e' },
                  compare: {
                    label: '较前月',
                    value: currentOwePay,
                    icon: 'el-icon-top',
                    style:
                      currentOwePay !== 0
                        ? { color: '#ff5010' }
                        : { color: '#24b153' }
                  }
                }
              ]
              salaryPay.charts.push({
                id: 'salaryPay',
                chartOption: getliquidfill(payRate, '累计发放率'),
                chartSize: {
                  width: '100%',
                  height: '230px'
                }
              })
            }
          }
        }
        const distRes = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/person/list/onsitestats',
            data: { orgUid: rootState.user.orgValue },
            noErrorMsg: true
          },
          { root: true }
        )
        const dist =
          distRes && distRes.code === 200 && distRes.data
            ? distRes.data
            : null
        if (dist) {
          const uniqueLabor = Number(
            dist.laborOnSite || dist.laboronsite || 0
          )
          const byAge = dist.byAge || dist.byage
          const byNative = dist.byNative || dist.bynative
          const byBusiness = dist.byBusiness || dist.bybusiness
          businessChart =
            pieChartFromRows(
              'businessdistribute',
              '工种',
              byBusiness,
              uniqueLabor
            ) || businessChart
          const ageFromDist = pieChartFromRows(
            'countnative',
            '年龄',
            byAge,
            uniqueLabor
          )
          const nativeFromDist = pieChartFromRows(
            'agedistribute',
            '籍贯',
            byNative,
            uniqueLabor
          )
          if (ageFromDist) ageChart = ageFromDist
          if (nativeFromDist) nativeChart = nativeFromDist
        }
        if (!businessChart) {
          businessChart = pieChartFromRows('businessdistribute', '工种', [], 0)
        }
        if (!ageChart) {
          ageChart = pieChartFromRows('agedistribute', '年龄', [], 0)
        }
        if (!nativeChart) {
          nativeChart = pieChartFromRows('countnative', '籍贯', [], 0)
        }
        statisticAnalysis = [
          salaryPay,
          laborComposeCard('在场劳务人员工种分布', businessChart),
          laborComposeCard('在场劳务人员年龄分布', ageChart),
          laborComposeCard('在场劳务人员籍贯分布', nativeChart)
        ]
        commit(
          'baseSet',
          {
            module: 'dataAnalysis',
            key: 'statisticAnalysis',
            value: statisticAnalysis
          },
          { root: true }
        )
      } else {
        commit(
          'baseSet',
          {
            module: 'dataAnalysis',
            key: 'statisticAnalysis',
            value: [
              laborComposeCard(
                '在场劳务人员工种分布',
                pieChartFromRows('businessdistribute', '工种', [], 0)
              ),
              laborComposeCard(
                '在场劳务人员年龄分布',
                pieChartFromRows('agedistribute', '年龄', [], 0)
              ),
              laborComposeCard(
                '在场劳务人员籍贯分布',
                pieChartFromRows('countnative', '籍贯', [], 0)
              )
            ]
          },
          { root: true }
        )
      }
    },
    // 获取用工趋势指标
    async getRealnameLabourTrend({ commit, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/query/project/monthworkers', data: data },
        { root: true }
      )
      // console.log(res)
      if (res.data) {
        const option = resetAttributes(res.data, ['monthDate', 'count'])
        let changeTrend = {
          charts: [
            {
              id: 'laborVolume',
              chartOption: getLine(option, ['月出勤人次'], ['人次']),
              chartSize: {
                width: '100%',
                height: '230px'
              }
            }
          ]
        }
        commit(
          'baseSet',
          { module: 'dataAnalysis', key: 'changeTrend', value: changeTrend },
          { root: true }
        )
      } else {
        commit(
          'baseSet',
          { module: 'dataAnalysis', key: 'changeTrend', value: [] },
          { root: true }
        )
      }
    },
    // 获取薪酬趋势指标数据
    async getRealnameSalaryPayTrend({ commit, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/query/project/shouldwages', data: data },
        { root: true }
      )
      // console.log(res)
      if (res.data) {
        const option = resetAttributes(res.data, [
          'currentMonth',
          'shouldPay',
          'actualPay'
        ])
        let changeTrend = {
          charts: [
            {
              id: 'laborVolume',
              chartOption: getBar(option, ['月应发金额', '月实发金额'], ['元']),
              chartSize: {
                width: '100%',
                height: '230px'
              }
            }
          ]
        }
        commit(
          'baseSet',
          { module: 'dataAnalysis', key: 'changeTrend', value: changeTrend },
          { root: true }
        )
      } else {
        commit(
          'baseSet',
          { module: 'dataAnalysis', key: 'changeTrend', value: [] },
          { root: true }
        )
      }
    },

    async getReportTemplates({ rootState, commit, dispatch }) {
      const meta = reportTemplateMeta(rootState)
      if (meta.org && !meta.orgUid) {
        commit(
          'baseSet',
          { module: 'dataAnalysis', key: 'templateTree', value: [] },
          { root: true }
        )
        return { code: 200, data: [] }
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: meta.org ? '/rule/report/org/list' : '/rule/report/system',
          data: meta.org ? { orgUid: meta.orgUid } : {}
        },
        { root: true }
      )
      const raw = res && res.code === 200 && Array.isArray(res.data) ? res.data : []
      const tree = decorateTemplateTree(
        buildTemplateTree(filterByCategory(raw, meta.category), meta.groups),
        meta.org ? 'org' : 'system'
      )
      commit(
        'baseSet',
        { module: 'dataAnalysis', key: 'templateTree', value: tree },
        { root: true }
      )
      return res
    },
    async loadAvailableTemplates({ rootState, commit, dispatch }) {
      const meta = reportTemplateMeta(rootState)
      if (!meta.orgUid) {
        commit(
          'baseSet',
          { module: 'dataAnalysis', key: 'availableTemplates', value: [] },
          { root: true }
        )
        return []
      }
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/rule/report/org/available', data: { orgUid: meta.orgUid } },
        { root: true }
      )
      const raw = res && res.code === 200 && Array.isArray(res.data) ? res.data : []
      const options = filterByCategory(raw, meta.category).map((item) => ({
        value: item.templateCode,
        label: (item.templateName || item.reportName) + '（' + item.templateCode + '）',
        templateCode: item.templateCode,
        templateName: item.templateName || item.reportName,
        templateGroupCode: item.templateGroupCode,
        templateGroupName: item.templateGroupName,
        sort: item.sort
      }))
      commit(
        'baseSet',
        { module: 'dataAnalysis', key: 'availableTemplates', value: options },
        { root: true }
      )
      return options
    },
    async saveSystemTemplate({ rootState, dispatch }, form) {
      const data = normalizeTemplateForm(form, rootState)
      const res = await dispatch(
        'baseRequest',
        {
          method: form && form.uid ? 'PUT' : 'POST',
          url: '/rule/report/system',
          data: data,
          msg: '保存成功'
        },
        { root: true }
      )
      if (res && res.code === 200) {
        await dispatch('getReportTemplates')
      }
      return res
    },
    async saveOrgTemplate({ rootState, dispatch }, form) {
      const data = normalizeTemplateForm(form, rootState)
      data.orgUid = rootState.activeNav
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/report/org/custom',
          data: data,
          msg: '保存成功'
        },
        { root: true }
      )
      if (res && res.code === 200) {
        await dispatch('getReportTemplates')
      }
      return res
    },
    async deleteOrgTemplate({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/rule/report/org/custom',
          data: { uid: uid },
          msg: '已删除'
        },
        { root: true }
      )
      if (res && res.code === 200) {
        await dispatch('getReportTemplates')
      }
      return res
    },
    async toggleOrgTemplate({ rootState, dispatch }, row) {
      const enabled = row && (row.isShow === true || row.isShow === 'true' || row.showLabel === '启用')
      const visible = !enabled
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/report/org/custom',
          data: {
            uid: row.customUid || row.uid,
            orgUid: rootState.activeNav,
            templateCode: row.templateCode,
            templateName: row.templateName || row.reportName,
            templateGroupCode: row.templateGroupCode,
            templateGroupName: row.templateGroupName,
            reportName: row.reportName || row.templateName,
            isShow: visible ? 'true' : 'false',
            sort: row.sort
          },
          msg: visible ? '已启用' : '已停用'
        },
        { root: true }
      )
      if (res && res.code === 200) {
        await dispatch('getReportTemplates')
      }
      return res
    },
    async sortReportTemplates({ rootState, dispatch }, payload) {
      const updates = (payload && payload.updates) || payload
      const meta = reportTemplateMeta(rootState)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: meta.org ? '/rule/report/org/sort' : '/rule/report/system/sort',
          data: updates,
          msg: '排序已更新'
        },
        { root: true }
      )
      if (res && res.code === 200) {
        await dispatch('getReportTemplates')
      }
      return res
    },

    /********************************************** 实名制数据报表 ********************************************************/

    // 获取实名制数据报表路由
    async getRealnameReportData({ rootState, rootGetters, commit, dispatch }, payload) {
      var orgUid = payload
      if (payload && typeof payload === 'object') {
        orgUid = payload.orgUid || payload.uid
      }
      if (!orgUid) {
        orgUid = rootState.user.orgValue
      }
      const decorate = (reports, type) => {
        const list = reports || []
        list.forEach((item, index) => {
          const key = 'reportUrl' + index + 1
          commit(
            'reportSet',
            {
              key: key,
              reportUid: item.uid,
              type: item.type || type || 'defaultreport',
              orgUid: rootState.user.orgValue
            },
            { root: true }
          )
          item.url = rootState.reports[key]
          item.value = item.url
          item.code = item.code || item.templateCode
          item.label = '报表' + (index + 1) + '\xa0\xa0' + item.name
        })
        return list
      }
      let groups = collectReportTemplates(rootGetters['user/pages'] || [])
      let apiGroups = []
      try {
        const res = await dispatch(
          'baseRequest',
          { method: 'GET', url: '/rule/report/config', data: { orgUid: orgUid } },
          { root: true }
        )
        apiGroups = (res && res.data && res.data[0] && res.data[0].group) || []
      } catch (e) {
        apiGroups = []
      }
      // 接口已按「系统模板 + 机构定制」解析；有结果时不再用菜单页把已停用的系统报表加回来
      groups = apiGroups.length ? mergeReportGroups(apiGroups, []) : groups
      const reportGroups = (groups || []).map((group) => ({
        code: group.code,
        name: group.name,
        reports: decorate((group && group.reports) || [], 'defaultreport')
      }))
      const manageGroup = reportGroups.find((item) => item.code === 'managerReport') || reportGroups[0]
      const checkGroup = reportGroups.find((item) => item.code === 'findReport') || reportGroups[1]
      const manageReport = filterByCategory((manageGroup && manageGroup.reports) || [], 'realname')
      const checkReport = filterByCategory((checkGroup && checkGroup.reports) || [], 'realname')
      const preClassReport = []
      reportGroups.forEach((group) => {
        filterByCategory((group && group.reports) || [], 'preClass').forEach((item) => {
          if (preClassReport.indexOf(item) < 0) preClassReport.push(item)
        })
      })
        commit(
          'baseSet',
          {
            module: 'dataAnalysis',
            key: 'reportGroups',
            value: reportGroups
          },
          { root: true }
        )
        commit(
          'baseSet',
          {
            module: 'dataAnalysis',
            key: 'realnameManageReport',
            value: manageReport
          },
          { root: true }
        )
        commit(
          'baseSet',
          {
            module: 'dataAnalysis',
            key: 'realnameCheckReport',
            value: checkReport
          },
          { root: true }
        )
        commit(
          'baseSet',
          {
            module: 'dataAnalysis',
            key: 'preClassReport',
            value: preClassReport
          },
          { root: true }
        )
    },
    /********************************************** 工程用车数据分析 ********************************************************/

    // 获取工程用车当前实时指标及分项数据
    async getOfficialCarAnalysis(
      { rootState, rootGetters, commit, dispatch },
      data
    ) {
      await dispatch(
        'officialCar/getOfficialCarList',
        {
          orgUid: data && data.orgUid ? data.orgUid : rootState.user.orgValue
        },
        { root: true }
      )
      const officialCarList = rootGetters['officialCar/carLists']
      const noExitCar = rootGetters['officialCar/noExitCar']
      const hasMonitor = rootGetters['officialCar/hasMonitor']
      const onlineCar = rootGetters['officialCar/onlineCar']
      var monitorIndexs = [
        {
          label: '在场设备',
          value: 0,
          icon: 'el-icon-truck',
          compares: [
            {
              label: '总数量',
              value: 0,
              style: { color: '#24b153' }
            }
          ],
          span: 6
        },
        {
          label: '保险合格率',
          value: '100%',
          icon: 'iconfont icon-anquan',
          compares: [
            {
              label: '未备案',
              value: 0,
              style: { color: '#ff5010' }
            },
            {
              label: '已过期',
              value: 0,
              style: { color: '#ff5010' }
            }
          ],
          span: 6
        },
        {
          label: '设备监控率',
          value: '100%',
          icon: 'iconfont icon-jiankongkongzhiguanlijianguan',
          compares: [
            {
              label: '已监控',
              value: 0,
              style: { color: '#24b153' }
            },
            {
              label: '未监控',
              value: 0,
              style: { color: '#ff5010' }
            }
          ],
          span: 6
        },
        {
          label: '监控在线率',
          value: '100%',
          icon: 'el-icon-connection',
          compares: [
            {
              label: '在线数量',
              value: 0,
              style: { color: '#24b153' }
            },
            {
              label: '离线数量',
              value: 0,
              style: { color: '#ff5010' }
            }
          ],
          span: 6
        }
      ]
      var statisticAnalysis = [
        {
          title: {
            icon: 'iconfont icon-icon_huabanfuben',
            name: '按机构组成'
          },
          charts: [
            {
              id: 'organ',
              name: '机构',
              allnum: officialCarList.length,
              chartOption: getPie([], '总设备数', '台'),
              chartSize: {
                width: '100%',
                height: '230px'
              }
            }
          ],
          span: 12
        },
        {
          title: {
            icon: 'iconfont icon-icon_huabanfuben',
            name: '按用途组成'
          },
          charts: [
            {
              id: 'type',
              name: '类型',
              allnum: officialCarList.length,
              chartOption: getPie([], '总设备数', '台'),
              chartSize: {
                width: '100%',
                height: '230px'
              }
            }
          ],
          span: 12
        }
      ]
      const types = getSameAttribute(
        rootState.dictionarys.carUsage,
        'label'
      ).values
      var changeTrend = {
        charts: [
          {
            id: 'officialCar',
            chartOption: getBar([], types, ['台']),
            chartSize: {
              width: '100%',
              height: '230px'
            }
          }
        ]
      }
      monitorIndexs[0].value = noExitCar.length
      monitorIndexs[0].compares[0].value = officialCarList.length
      monitorIndexs[1].compares[0].value = noExitCar.filter((item) => {
        return item.isExpired === '未备案'
      }).length
      monitorIndexs[1].compares[1].value = noExitCar.filter((item) => {
        return item.isExpired === '已过期'
      }).length
      monitorIndexs[1].value =
        (
          ((noExitCar.length -
            monitorIndexs[1].compares[0].value -
            monitorIndexs[1].compares[1].value) /
            noExitCar.length) *
          100
        ).toFixed(1) + '%'
      monitorIndexs[2].compares[0].value = hasMonitor.length
      monitorIndexs[2].compares[1].value = noExitCar.length - hasMonitor.length
      monitorIndexs[2].value = monitorIndexs[0].value
        ? (
            (monitorIndexs[2].compares[0].value / noExitCar.length) *
            100
          ).toFixed(1) + '%'
        : '0.0%'
      monitorIndexs[3].compares[0].value = onlineCar.length
      monitorIndexs[3].compares[1].value =
        monitorIndexs[2].compares[0].value - onlineCar.length
      monitorIndexs[3].value =
        onlineCar.length && monitorIndexs[2].compares[0].value
          ? (
              (monitorIndexs[3].compares[0].value /
                monitorIndexs[2].compares[0].value) *
              100
            ).toFixed(1) + '%'
          : '0.0%'
      const classifyOrg = classifyArray(
        noExitCar,
        isAnalysisCompanyOrg(rootGetters['user/orgType'])
          ? 'vprojectName'
          : 'laborCompanyName'
      )
      const orgClass = Object.keys(classifyOrg).map((key) => {
        return { label: key, value: classifyOrg[key].length }
      })
      const classifyType = classifyArray(noExitCar, 'carUsage')
      const typeClass = Object.keys(classifyType).map((key) => {
        return { label: key, value: classifyType[key].length }
      })
      statisticAnalysis[0].charts[0].chartOption = getPie(
        orgClass,
        '在场设备',
        '台'
      )
      statisticAnalysis[1].charts[0].chartOption = getPie(
        typeClass,
        '在场设备',
        '台'
      )
      if (data && data.timeSlot) {
        const start = new Date(data.timeSlot[0])
        const end = new Date(data.timeSlot[1])
        let carChange = []
        const carClass = {}
        types.forEach((item, index) => {
          const key = 'value' + (index ? index + 1 : '')
          carClass[key] = 0
        })
        // 添加起始月份
        carChange.push(Object.assign({}, { label: data.timeSlot[0] }, carClass))
        // 循环获取中间月份
        let currentMonth = new Date(start)
        while (currentMonth < end) {
          currentMonth.setMonth(currentMonth.getMonth() + 1)
          carChange.push(
            Object.assign({}, { label: monthFormat(currentMonth) }, carClass)
          )
        }
        carChange = officialCarList.reduce((per, cur) => {
          per.forEach((item) => {
            if (
              new Date(item.label) >= new Date(monthFormat(cur.entryDate)) &&
              (!cur.exit ||
                (cur.exit && new Date(item.label) <= new Date(cur.exitDate)))
            ) {
              if (types.indexOf(cur.carUsage) !== -1) {
                const valueKey =
                  'value' +
                  (types.indexOf(cur.carUsage)
                    ? types.indexOf(cur.carUsage) + 1
                    : '')
                item[valueKey] = item[valueKey] ? item[valueKey] + 1 : 1
              }
            }
          })
          return per
        }, carChange)
        changeTrend.charts[0].chartOption = getBar(carChange, types, ['台'])
      }
      commit(
        'baseSet',
        {
          module: 'dataAnalysis',
          key: 'monitorIndexs',
          value: monitorIndexs
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'dataAnalysis',
          key: 'statisticAnalysis',
          value: statisticAnalysis
        },
        { root: true }
      )
      commit(
        'baseSet',
        { module: 'dataAnalysis', key: 'changeTrend', value: changeTrend },
        { root: true }
      )
    },

    async getPlatformOrgOverview({ commit, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/organize/org/overview' },
        { root: true }
      )
      const data = res.data || {}
      commit(
        'baseSet',
        { module: 'dataAnalysis', key: 'platformOrgOverview', value: data },
        { root: true }
      )
      return data
    },

    async getPlatformPersonOverview({ commit, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/person/list/overview' },
        { root: true }
      )
      const data = normalizePlatformOverview(res.data || {})
      commit(
        'baseSet',
        {
          module: 'dataAnalysis',
          key: 'platformPersonOverview',
          value: data
        },
        { root: true }
      )
      return data
    },

    async getPlatformCarOverview({ commit, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/organize/car/overview' },
        { root: true }
      )
      const data = normalizePlatformOverview(res.data || {})
      commit(
        'baseSet',
        { module: 'dataAnalysis', key: 'platformCarOverview', value: data },
        { root: true }
      )
      return data
    },

    async getPreClassAnalysis({ rootState, rootGetters, commit, dispatch }, arg) {
      const orgType = rootGetters['user/orgType']
      const payload =
        arg && typeof arg === 'object' && !Array.isArray(arg) ? arg : { isCompany: arg }
      const isCompanyArg = payload.isCompany
      const cumulFrom =
        payload.cumulFrom != null ? String(payload.cumulFrom) : ''
      const isLabor = isAnalysisLaborOrg(orgType)
      const isCompany = isAnalysisCompanyOrg(orgType)
        ? true
        : isAnalysisBidOrg(orgType)
          ? false
          : !!isCompanyArg
      const pickNum = (obj, keys, fallback) => {
        if (!obj) return fallback
        for (let i = 0; i < keys.length; i++) {
          const value = obj[keys[i]]
          if (value !== undefined && value !== null && value !== '') {
            const num = Number(value)
            if (!isNaN(num)) return num
          }
        }
        return fallback
      }
      const countItem = (label, value) => {
        const num = Number(value) || 0
        const warn = label.indexOf('未') === 0
        return {
          label: label,
          value: num,
          style: kpiCountStyle(warn)
        }
      }
      const rateItem = (label, value) => {
        const num = Number(value) || 0
        return {
          label: label,
          value: num + '%',
          style: kpiRateStyle()
        }
      }
      const reqData = { orgUid: rootState.user.orgValue }
      if (cumulFrom) {
        reqData.cumulFrom = cumulFrom
      }
      let auxiliaryPromise = null
      if (isCompany) {
        auxiliaryPromise = dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/organize/temp/projectinfolist',
            data: {
              page: 1,
              limit: 1000,
              parentCompanyUid: rootState.user.orgValue
            },
            noErrorMsg: true
          },
          { root: true }
        )
      } else if (!isLabor) {
        auxiliaryPromise = dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/query/team/levelinfo',
            data: { organUid: rootState.user.orgValue },
            noErrorMsg: true
          },
          { root: true }
        )
      }
      const [res, auxiliaryRes] = await Promise.all([
        dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/organize/cultivate/educlassstats',
            data: reqData,
            noErrorMsg: true
          },
          { root: true }
        ),
        auxiliaryPromise || Promise.resolve(null)
      ])
      const stats = res && res.code === 200 && res.data ? res.data : {}
      const todayPending = pickNum(stats, ['todayPending', 'todaypending'], 0)
      const todayRegularDone = pickNum(
        stats,
        ['todayRegularDone', 'todayregulardone'],
        0
      )
      const todayRectify = pickNum(stats, ['todayRectify', 'todayrectify'], 0)
      const todayUnrectify = pickNum(
        stats,
        ['todayUnrectify', 'todayunrectify'],
        0
      )
      const onSitePerson = pickNum(stats, ['onSitePerson', 'onsiteperson'], 0)
      const expectedPersonTimes = pickNum(
        stats,
        ['expectedPersonTimes', 'expectedpersontimes'],
        onSitePerson
      )
      const signedPersonTimes = pickNum(
        stats,
        ['signedPersonTimes', 'signedpersontimes', 'signedPerson', 'signedperson'],
        0
      )
      const onSiteTeam = pickNum(stats, ['onSiteTeam', 'onsiteteam'], 0)
      const onSiteLaborCompany = pickNum(
        stats,
        ['onSiteLaborCompany', 'onsitelaborcompany'],
        0
      )
      const buildingBid = pickNum(stats, ['buildingBid', 'buildingbid'], 0)
      const undoneTeamCount = pickNum(
        stats,
        ['undoneTeamCount', 'undoneteamcount'],
        0
      )
      const undoneLaborCount = pickNum(
        stats,
        ['undoneLaborCount', 'undonelaborcount'],
        0
      )
      const undoneBidCount = pickNum(
        stats,
        ['undoneBidCount', 'undonebidcount'],
        0
      )
      const undoneTeams = (stats.undoneTeams || stats.undoneteams || []).map(
        (row) => ({
          teamName: row.teamName || row.teamname || '',
          laborName: row.laborName || row.laborname || '',
          bidName: row.bidName || row.bidname || '',
          undoType: row.undoType || row.undotype || ''
        })
      )
      const doneTeamCount = Math.max(onSiteTeam - undoneTeamCount, 0)
      // 劳务公司合格依赖下级班组：无在场班组时按 0/0→0% 计
      const doneLaborCount =
        onSiteTeam > 0 ? Math.max(onSiteLaborCompany - undoneLaborCount, 0) : 0
      // 标段：无班组直接不合格；有班组则其下劳务公司须全部合格
      const doneBidCount = Math.max(buildingBid - undoneBidCount, 0)
      const todayNoEduTeamCount = pickNum(
        stats,
        ['todayNoEduTeamCount', 'todaynoeduteamcount'],
        0
      )
      const pct = (num, den) =>
        den > 0 ? Number(((num / den) * 100).toFixed(1)) : 0
      const clickCount = (label, value, scope) => {
        const item = countItem(label, value)
        item.clickable = true
        item.clickAction = 'undoneEdu'
        item.clickScope = scope || ''
        return item
      }
      const todayPendingTotal = todayPending + todayNoEduTeamCount
      const todayRate = pct(todayRegularDone, todayRegularDone + todayPendingTotal)
      const rectifyRate = pct(todayRectify, todayRectify + todayUnrectify)
      const personRate = pct(signedPersonTimes, expectedPersonTimes)
      const teamRate = pct(doneTeamCount, onSiteTeam)
      const laborRate =
        onSiteTeam > 0 ? pct(doneLaborCount, onSiteLaborCompany) : 0
      const bidRate = pct(doneBidCount, buildingBid)
      const coreKpis = [
        {
          label: '今日班前教育',
          value: todayRegularDone,
          icon: 'el-icon-reading',
          compares: [
            countItem('待执行', todayPendingTotal),
            rateItem('执行率', todayRate)
          ]
        },
        {
          label: '今日教育整改',
          value: todayRectify,
          icon: 'el-icon-s-claim',
          compares: [
            countItem('待整改', todayUnrectify),
            rateItem('整改率', rectifyRate)
          ]
        },
        {
          label: '今日人员覆盖率',
          value: personRate + '%',
          icon: 'iconfont icon-gongren',
          compares: [
            countItem('应教育人次', expectedPersonTimes),
            countItem('签到人次', signedPersonTimes)
          ]
        },
        {
          label: '今日班组合格率',
          value: teamRate + '%',
          icon: 'iconfont icon-gongzuojingyan',
          compares: [
            countItem('在场班组', onSiteTeam),
            clickCount('未完成教育', undoneTeamCount, 'team')
          ]
        }
      ]
      const laborCompanyKpi = {
        label: '今日劳务公司合格率',
        value: laborRate + '%',
        icon: 'iconfont icon-gongsi',
        compares: [
          countItem('在场劳务公司', onSiteLaborCompany),
          clickCount('未完成教育', undoneLaborCount, 'labor')
        ]
      }
      const bidKpi = {
        label: '今日标段合格率',
        value: bidRate + '%',
        icon: 'iconfont icon-category',
        compares: [
          countItem('在建标段', buildingBid),
          clickCount('未完成教育', undoneBidCount, 'bid')
        ]
      }
      const laborKpis = coreKpis
      const bidKpis = coreKpis.concat([laborCompanyKpi])
      const companyKpis = bidKpis.concat([bidKpi])
      const pieCard = (
        id,
        title,
        rows,
        centerName,
        subLabelKeys,
        joinLabelKeys
      ) => {
        const chart = pieChartFromRows(
          id,
          title,
          rows,
          0,
          centerName || '未完成教育',
          '次',
          subLabelKeys,
          joinLabelKeys
        )
        return {
          label: title,
          title: {
            icon: 'el-icon-reading',
            name: title
          },
          charts: [chart],
          span: 12
        }
      }
      const mapCoverageRows = (list, nameKeys, fallbackName) =>
        (list || []).map((row) => {
          let name = fallbackName
          for (let i = 0; i < nameKeys.length; i++) {
            const value = row[nameKeys[i]]
            if (value !== undefined && value !== null && String(value).trim() !== '') {
              name = String(value).trim()
              break
            }
          }
          const onSite = Number(row.onSite || row.onsite || 0)
          const eduCount = Number(row.eduCount || row.educount || 0)
          const expectedFromParts = onSite * Math.max(eduCount, 1)
          return {
            name,
            onSite,
            eduCount,
            laborCount: Number(row.laborCount || row.laborcount || 0),
            teamCount: Number(row.teamCount || row.teamcount || 0),
            doneTeamCount: Number(
              row.doneTeamCount ||
                row.doneteamcount ||
                row.done_team_count ||
                0
            ),
            expectedTimes: Number(
              row.expectedTimes != null
                ? row.expectedTimes
                : row.expectedtimes != null
                  ? row.expectedtimes
                  : expectedFromParts
            ),
            signed: Number(row.signed || 0),
            coverage:
              (row.coverage == null ? '0.0' : String(row.coverage)) +
              (String(row.coverage || '').indexOf('%') >= 0 ? '' : '%')
          }
        })
      const orgRankColumns = (withLaborCount) => {
        const cols = [
          { prop: 'name', label: withLaborCount ? '标段' : '劳务公司', minWidth: 120, align: 'left' }
        ]
        if (withLaborCount) {
          cols.push({ prop: 'laborCount', label: '在场劳务公司', width: 110 })
        }
        cols.push(
          { prop: 'teamCount', label: '在场班组', width: 88 },
          { prop: 'doneTeamCount', label: '完成教育班组', width: 110 },
          { prop: 'expectedTimes', label: '应教育人次', width: 100 },
          { prop: 'signed', label: '签到人次', width: 88 },
          { prop: 'coverage', label: '覆盖率', width: 80 }
        )
        return cols
      }
      const coverageTable = (title, icon, nameLabel, rows, columns) => ({
        label: title,
        type: 'table',
        title: {
          icon,
          name: title
        },
        span: 12,
        columns: columns || [
          { prop: 'name', label: nameLabel, minWidth: 120, align: 'left' },
          { prop: 'onSite', label: '在场人数', width: 88 },
          { prop: 'doneTeamCount', label: '完成教育班组', width: 110 },
          { prop: 'expectedTimes', label: '应教育人次', width: 100 },
          { prop: 'signed', label: '签到人次', width: 88 },
          { prop: 'coverage', label: '覆盖率', width: 80 }
        ],
        rows
      })
      const laborCoverageRank = coverageTable(
        '今日人员覆盖率按劳务公司排序',
        'iconfont icon-gongsi',
        '劳务公司',
        mapCoverageRows(
          stats.coverageByLabor || stats.coveragebylabor,
          ['companyName', 'companyname', 'label'],
          '未知劳务公司'
        ),
        orgRankColumns(false)
      )
      const bidCoverageRank = coverageTable(
        '今日人员覆盖率按标段排序',
        'iconfont icon-category',
        '标段',
        mapCoverageRows(
          stats.coverageByBid || stats.coveragebybid,
          ['bidName', 'bidname', 'name', 'label'],
          '未知标段'
        ),
        orgRankColumns(true)
      )
      const teamCoverageRank = coverageTable(
        '今日人员覆盖率按班组排序',
        'iconfont icon-gongzuojingyan',
        '班组',
        mapCoverageRows(
          stats.coverageByTeam || stats.coveragebyteam,
          ['teamName', 'teamname', 'name', 'label'],
          '未知班组'
        )
      )
      const companyCharts = [
        bidCoverageRank,
        pieCard(
          'preClassRectifyTeam',
          '累计被要求整改班组分布',
          stats.byRectifyTeam || stats.byrectifyteam,
          '累计整改次数',
          ['bidName', 'bidname', 'bid_name'],
          ['laborName', 'laborname', 'labor_name']
        ),
        pieCard(
          'preClassUndoneLabor',
          '在场劳务公司累计不合格教育次数分布',
          stats.byUndoneLabor || stats.byundonelabor,
          '累计不合格教育次数',
          ['bidName', 'bidname', 'bid_name']
        ),
        pieCard(
          'preClassUndoneBid',
          '在建标段累计不合格教育次数分布',
          stats.byUndoneBid || stats.byundonebid,
          '累计不合格教育次数'
        )
      ]
      const bidCharts = [
        laborCoverageRank,
        pieCard(
          'preClassRectifyTeam',
          '累计被要求整改班组分布',
          stats.byRectifyTeam || stats.byrectifyteam,
          '累计整改次数',
          ['laborName', 'laborname', 'labor_name']
        ),
        pieCard(
          'preClassUndoneTeam',
          '在场班组累计不合格教育次数分布',
          stats.byUndoneTeam || stats.byundoneteam,
          '累计不合格教育次数',
          ['laborName', 'laborname', 'labor_name']
        ),
        pieCard(
          'preClassUndoneLabor',
          '在场劳务公司累计不合格教育次数分布',
          stats.byUndoneLabor || stats.byundonelabor,
          '累计不合格教育次数'
        )
      ]
      const personEduRank = coverageTable(
        '在场人员累计受教育次数排序',
        'iconfont icon-gongren',
        '人员',
        (stats.onSitePersonEduRank || stats.onsitepersonedurank || []).map((row) => ({
          name: row.name || row.personName || row.personname || '未知人员',
          teamName: row.teamName || row.teamname || '',
          eduTimes: Number(row.eduTimes != null ? row.eduTimes : row.edutimes || 0)
        })),
        [
          { prop: 'name', label: '人员姓名', minWidth: 100, align: 'left' },
          { prop: 'teamName', label: '班组', minWidth: 120, align: 'left' },
          { prop: 'eduTimes', label: '受教育次数', width: 110 }
        ]
      )
      const laborCharts = [
        teamCoverageRank,
        personEduRank,
        pieCard(
          'preClassRectifyTeam',
          '累计被要求整改班组分布',
          stats.byRectifyTeam || stats.byrectifyteam,
          '累计整改次数'
        ),
        pieCard(
          'preClassUndoneTeam',
          '在场班组累计不合格教育次数分布',
          stats.byUndoneTeam || stats.byundoneteam,
          '累计不合格教育次数'
        )
      ]
      let trendBids = mapTrendBids(stats.trendBids || stats.trendbids)
      let trendLabors = mapTrendLabors(stats.trendLabors || stats.trendlabors)
      let trendTeams = mapTrendTeams(stats.trendTeams || stats.trendteams)
      if (isCompany) {
        const listRes = auxiliaryRes
        const rows =
          listRes && listRes.data
            ? Array.isArray(listRes.data.result)
              ? listRes.data.result
              : Array.isArray(listRes.data.records)
                ? listRes.data.records
                : Array.isArray(listRes.data)
                  ? listRes.data
                  : []
            : []
        trendBids = mergeTrendBids(mapTrendBids(rows), trendBids)
      } else if (!isLabor) {
        const orgUid = rootState.user.orgValue
        const listRes = auxiliaryRes
        const rows = Array.isArray(listRes && listRes.data) ? listRes.data : []
        const fromLevel = rows
          .filter((item) => !item.upVproUid || item.upVproUid === orgUid)
          .map((item) => ({
            uid:
              item.vProjectUid ||
              item.vprojectuid ||
              item.orgUid ||
              item.org_uid,
            name:
              item.vProjectName ||
              item.vprojectname ||
              item.orgName ||
              item.org_name
          }))
        trendLabors = mergeTrendBids(mapTrendLabors(fromLevel), trendLabors)
      }
      const changeTrend = buildPreClassTrend(
        stats.monthTrend || stats.monthtrend || []
      )
      const pageKpis = isCompany ? companyKpis : isLabor ? laborKpis : bidKpis
      const pageCharts = isCompany
        ? companyCharts
        : isLabor
          ? laborCharts
          : bidCharts
      commit(
        'baseSet',
        {
          module: 'dataAnalysis',
          key: 'preClassKpis',
          value: pageKpis
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'dataAnalysis',
          key: 'preClassCharts',
          value: pageCharts
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'dataAnalysis',
          key: 'preClassTrend',
          value: changeTrend
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'dataAnalysis',
          key: 'preClassUndone',
          value: Array.isArray(undoneTeams) ? undoneTeams : []
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'dataAnalysis',
          key: 'preClassTrendBids',
          value: trendBids
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'dataAnalysis',
          key: 'preClassTrendLabors',
          value: trendLabors
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'dataAnalysis',
          key: 'preClassTrendTeams',
          value: trendTeams
        },
        { root: true }
      )
    },
    async getPreClassTrend({ rootState, commit, dispatch }, payload) {
      const bidUid =
        payload && typeof payload === 'object' ? payload.bidUid : payload
      const laborCompanyUid =
        payload && typeof payload === 'object' ? payload.laborCompanyUid : ''
      const teamUid =
        payload && typeof payload === 'object' ? payload.teamUid : ''
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/cultivate/educlasstrend',
          data: {
            orgUid: rootState.user.orgValue,
            bidUid: bidUid || '',
            laborCompanyUid: laborCompanyUid || '',
            teamUid: teamUid || ''
          },
          noErrorMsg: true
        },
        { root: true }
      )
      const rows =
        res && res.code === 200
          ? Array.isArray(res.data)
            ? res.data
            : []
          : []
      commit(
        'baseSet',
        {
          module: 'dataAnalysis',
          key: 'preClassTrend',
          value: buildPreClassTrend(rows)
        },
        { root: true }
      )
    },
    async getMaterialAnalysis({ rootState, commit, dispatch }, payload) {
      const orgUid =
        payload && payload.orgUid ? payload.orgUid : rootState.user.orgValue
      const projectUid =
        payload && payload.projectUid ? payload.projectUid : ''
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/goods/analysis/overview',
          data: { orgUid: orgUid, projectUid: projectUid },
          noErrorMsg: true
        },
        { root: true }
      )
      const data = res && res.code === 200 && res.data ? res.data : {}
      const kpis = data.kpis || {}
      const num = (value) =>
        value == null || isNaN(Number(value)) ? 0 : Number(value)
      const kpi = (label, value, icon, money) => ({
        label: label,
        value: money
          ? formatMoney(value)
          : Number.isInteger(value)
          ? String(value)
          : Number(value).toFixed(2),
        icon: icon,
        span: 4,
        compares: []
      })
      const monitorIndexs = [
        kpi('累计入库金额', num(kpis.inboundAmount), 'el-icon-box', true),
        kpi(
          '累计入库数量',
          num(kpis.inboundQuantity),
          'el-icon-download',
          false
        ),
        kpi(
          '累计领用出库金额',
          num(kpis.outboundAmount),
          'el-icon-upload2',
          true
        ),
        kpi(
          '累计领用数量',
          num(kpis.outboundQuantity),
          'el-icon-upload',
          false
        ),
        kpi(
          '当前理论库存金额',
          num(kpis.inventoryAmount),
          'el-icon-s-data',
          true
        ),
        kpi(
          '在用物资种类数',
          num(kpis.goodsTypeCount),
          'el-icon-collection',
          false
        )
      ]
      const chartCard = (id, label, icon, rows, centerName, unit) => ({
        label: label,
        title: { icon: icon, name: label },
        charts: [
          {
            id: id,
            chartOption:
              rows && rows.length
                ? getPie(chartRows(rows), centerName, unit)
                : getEmptyPie(centerName, unit),
            chartSize: { width: '100%', height: '230px' }
          }
        ],
        span: 12
      })
      const charts = [
        chartCard(
          'materialCategoryPie',
          '物资大类入库金额占比',
          'el-icon-box',
          data.categoryPie,
          '入库金额',
          '元'
        ),
        chartCard(
          'materialTypePie',
          '物资子类型入库金额占比',
          'el-icon-collection',
          data.typePie,
          '入库金额',
          '元'
        ),
        {
          label: '近12个月出入库金额趋势',
          title: {
            icon: 'el-icon-s-data',
            name: '近12个月出入库金额趋势'
          },
          charts: [
            {
              id: 'materialMonthTrend',
              chartOption: getBar(
                data.monthTrend || [],
                ['入库金额', '出库金额'],
                ['元', '元']
              ),
              chartSize: { width: '100%', height: '260px' }
            }
          ],
          span: 24
        }
      ]
      const inventoryRows = (data.inventoryRows || []).map((item) => ({
        goodsName: item.goodsName || '',
        goodsType: item.goodsType || '',
        unit: item.unit || '',
        inboundQuantity: item.inboundQuantity || 0,
        inboundAmount: item.inboundAmount || 0,
        outboundQuantity: item.outboundQuantity || 0,
        outboundAmount: item.outboundAmount || 0,
        inventoryQuantity: item.inventoryQuantity || 0
      }))
      commit(
        'baseSet',
        {
          module: 'dataAnalysis',
          key: 'materialAnalysis',
          value: {
            monitorIndexs: monitorIndexs,
            charts: charts,
            inventoryRows: inventoryRows
          }
        },
        { root: true }
      )
    }
  }
}

function pickMapText(item, keys) {
  if (!item) return ''
  for (let i = 0; i < keys.length; i++) {
    const value = item[keys[i]]
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      return String(value).trim()
    }
  }
  const lower = {}
  Object.keys(item).forEach((key) => {
    lower[String(key).toLowerCase()] = item[key]
  })
  for (let i = 0; i < keys.length; i++) {
    const value = lower[String(keys[i]).toLowerCase()]
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      return String(value).trim()
    }
  }
  return ''
}

function mapTrendBids(list) {
  return (list || [])
    .map((item) => ({
      uid: pickMapText(item, ['uid', 'orgUid', 'org_uid', 'value']),
      name: pickMapText(item, [
        'orgCode',
        'org_code',
        'name',
        'orgName',
        'org_name',
        'label'
      ])
    }))
    .filter((item) => item.uid)
    .map((item) => ({
      uid: item.uid,
      name: item.name || '未知标段'
    }))
}

function mapTrendLabors(list) {
  return (list || [])
    .map((item) => ({
      uid: pickMapText(item, [
        'uid',
        'orgUid',
        'org_uid',
        'value',
        'vProjectUid',
        'vprojectuid'
      ]),
      name: pickMapText(item, [
        'name',
        'orgName',
        'org_name',
        'label',
        'vProjectName',
        'vprojectname',
        'companyName',
        'companyname'
      ])
    }))
    .filter((item) => item.uid)
    .map((item) => ({
      uid: item.uid,
      name: item.name || '未知劳务公司'
    }))
}

function mapTrendTeams(list) {
  return (list || [])
    .map((item) => ({
      uid: pickMapText(item, [
        'uid',
        'orgUid',
        'org_uid',
        'teamUid',
        'teamuid',
        'value'
      ]),
      name: pickMapText(item, [
        'name',
        'teamName',
        'teamname',
        'orgName',
        'org_name',
        'label'
      ])
    }))
    .filter((item) => item.uid)
    .map((item) => ({
      uid: item.uid,
      name: item.name || '未知班组'
    }))
}

function mergeTrendBids(primary, secondary) {
  const seen = {}
  const result = []
  ;[].concat(primary || [], secondary || []).forEach((item) => {
    if (!item || !item.uid || seen[item.uid]) {
      return
    }
    seen[item.uid] = true
    result.push({
      uid: item.uid,
      name: item.name || '未知标段'
    })
  })
  return result
}

function buildPreClassTrend(source) {
  const trendRows = (source || [])
    .map((item) => ({
      label: item.label || item.LABEL || '',
      value: Number(item.value || item.VALUE || 0),
      value2: Number(item.value2 || item.VALUE2 || 0)
    }))
    .filter((item) => item.label)
  return {
    charts: [
      {
        id: 'preClassTrend',
        chartOption: getBar(trendRows, ['班前教育次数', '签到人次'], [
          '次',
          '人次'
        ]),
        chartSize: {
          width: '100%',
          height: '230px'
        }
      }
    ]
  }
}

function chartRows(list, subLabelKeys, joinLabelKeys) {
  return (list || [])
    .map((item) => {
      const explicitLabel =
        item.label ||
        item.LABEL ||
        item.teamName ||
        item.teamname ||
        ''
      const keys = Array.isArray(subLabelKeys) ? subLabelKeys : []
      let subLabel = ''
      for (let i = 0; i < keys.length; i++) {
        const value = item[keys[i]]
        if (value !== undefined && value !== null && String(value).trim() !== '') {
          subLabel = String(value).trim()
          break
        }
      }
      const joinKeys = Array.isArray(joinLabelKeys) ? joinLabelKeys : []
      let joinLabel = ''
      for (let i = 0; i < joinKeys.length; i++) {
        const value = item[joinKeys[i]]
        if (value !== undefined && value !== null && String(value).trim() !== '') {
          joinLabel = String(value).trim()
          break
        }
      }
      const finalSubLabel = joinLabel
        ? subLabel
          ? subLabel + '/' + joinLabel
          : joinLabel
        : subLabel
      return {
        label:
          explicitLabel ||
          item.bidName ||
          item.bidname ||
          item.bid_name ||
          '',
        subLabel: explicitLabel ? finalSubLabel : '',
        value: Number(
          item.value ||
            item.VALUE ||
            item.itemCount ||
            item.itemcount ||
            0
        )
      }
    })
    .filter((item) => item.label)
}

function normalizePlatformOverview(data) {
  const next = { ...data }
  ;['byProject', 'byBid', 'byCompany', 'byBusiness', 'byUsage'].forEach(
    (key) => {
      if (next[key]) {
        next[key] = chartRows(next[key])
      }
    }
  )
  if (Array.isArray(next.rank)) {
    next.rank = next.rank.map((row, index) => ({
      index: index + 1,
      bidName:
        row.bidName || row.bidname || row.bid_name || row.label || '未知标段',
      laborCompanyCount: Number(
        row.laborCompanyCount ||
          row.laborcompanycount ||
          row.labor_company_count ||
          0
      ),
      manageCompanyCount: Number(
        row.manageCompanyCount ||
          row.managecompanycount ||
          row.manage_company_count ||
          0
      ),
      teamCount: Number(row.teamCount || row.teamcount || row.team_count || 0),
      laborCount: Number(
        row.laborCount || row.laborcount || row.labor_count || 0
      ),
      adminCount: Number(
        row.adminCount || row.admincount || row.admin_count || 0
      ),
      attendanceRate: formatPercent(
        row.attendanceRate || row.attendancerate || row.attendance_rate
      ),
      contractRate: formatPercent(
        row.contractRate || row.contractrate || row.contract_rate
      ),
      salaryAmount: formatMoney(
        row.salaryAmount || row.salaryamount || row.salary_amount
      ),
      payRate: formatPercent(row.payRate || row.payrate || row.pay_rate)
    }))
  }
  return next
}

function laborComposeCard(name, chart) {
  return {
    label: name,
    title: {
      icon: 'iconfont icon-icon_huabanfuben',
      name: name
    },
    charts: chart ? [chart] : [],
    span: 12
  }
}

function topWithOthers(rows, uniqueTotal, subLabelKeys, joinLabelKeys) {
  const list = chartRows(rows, subLabelKeys, joinLabelKeys)
    .filter((item) => Number(item.value || 0) > 0)
    .sort((a, b) => Number(b.value || 0) - Number(a.value || 0))
  let result = list
  if (list.length > 6) {
    const top = list.slice(0, 6)
    const rest = list
      .slice(6)
      .reduce((sum, item) => sum + Number(item.value || 0), 0)
    if (rest > 0) {
      top.push({ label: '其他', value: rest })
    }
    result = top
  }
  const sum = result.reduce((acc, item) => acc + Number(item.value || 0), 0)
  const unique = Number(uniqueTotal || 0)
  if (unique > sum) {
    const gap = unique - sum
    const other = result.find((item) => item.label === '其他')
    if (other) {
      other.value = Number(other.value || 0) + gap
    } else {
      result = result.concat([{ label: '其他', value: gap }])
    }
  }
  return result
}

function pieChartFromRows(
  id,
  name,
  rows,
  uniqueTotal,
  centerName,
  unit,
  subLabelKeys,
  joinLabelKeys
) {
  const element = topWithOthers(rows, uniqueTotal, subLabelKeys, joinLabelKeys)
  const sliceTotal = element.reduce(
    (acc, item) => acc + Number(item.value || 0),
    0
  )
  const unique = Number(uniqueTotal || 0)
  const total = unique > 0 ? unique : sliceTotal
  const title = centerName || '在场劳务人员'
  const unitText = unit || '人'
  if (!element.length || total === 0) {
    return {
      id,
      name,
      chartOption: getEmptyPie(title, unitText),
      chartSize: {
        width: '100%',
        height: '230px'
      }
    }
  }
  const legendRows = {}
  const pieRows = element.map((item, index) => {
    const key = item.subLabel
      ? item.label + '\u0001' + item.subLabel + '\u0001' + index
      : item.label
    legendRows[key] = item
    return Object.assign({}, item, { label: key })
  })
  const option = getPie(pieRows, title, unitText)
  if (option.series && option.series[0] && option.series[0].label) {
    option.series[0].label.formatter = title + '\n\n' + total + '\xa0' + unitText
    option.series[0].label.fontSize = 14
  }
  if (option.legend) {
    option.legend.itemGap = 12
    option.legend.itemWidth = 14
    option.legend.itemHeight = 14
    option.legend.padding = [8, 0]
    option.legend.textStyle = {
      fontSize: 12,
      lineHeight: 18
    }
    if (element.some((item) => item.subLabel)) {
      const richText = (value) =>
        String(value || '').replace(/[{}]/g, '').replace(/\n/g, ' ')
      option.legend.itemGap = 4
      option.legend.textStyle = {
        fontSize: 12,
        lineHeight: 27,
        rich: {
          name: {
            fontSize: 12,
            lineHeight: 15,
            color: '#303133'
          },
          sub: {
            fontSize: 10,
            lineHeight: 12,
            color: '#909399'
          }
        }
      }
      option.legend.formatter = (key) => {
        const item = legendRows[key]
        if (!item) return key
        const nameLine =
          richText(item.label) + ' (' + item.value + '\xa0' + unitText + ')'
        return item.subLabel
          ? '{name|' + nameLine + '}\n{sub|' + richText(item.subLabel) + '}'
          : nameLine
      }
      option.tooltip.formatter = (params) => {
        const item = legendRows[params.name]
        if (!item) return params.name + '<br/>' + params.value
        return (
          richText(item.label) +
          (item.subLabel ? '<br/>' + richText(item.subLabel) : '') +
          '<br/>' +
          params.value +
          '\xa0' +
          unitText +
          ' (' +
          params.percent +
          '%)'
        )
      }
    }
  }
  return {
    id,
    name,
    chartOption: option,
    chartSize: {
      width: '100%',
      height: '230px'
    }
  }
}

function formatPercent(value) {
  if (value == null || value === '') return '0.0%'
  const text = String(value)
  if (text.indexOf('%') >= 0) return text
  const num = Number(value)
  if (Number.isNaN(num)) return '0.0%'
  return num.toFixed(1) + '%'
}

function formatMoney(value) {
  if (value == null || value === '') return '0.00'
  const num = Number(value)
  if (Number.isNaN(num)) return '0.00'
  return num.toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}
